export function gotoPageAfterXSecond(params) {
  if (typeof params != 'undefined' && params.hasOwnProperty('goto_url')) {
    setTimeout(function() {
      window.location = params['goto_url'];
    }, 2000);
  }
}

export function checkNested(obj /*, level1, level2, ... levelN*/) {
  var args = Array.prototype.slice.call(arguments, 1);

  for (var i = 0; i < args.length; i++) {
    if (!obj || !obj.hasOwnProperty(args[i])) {
      return false;
    }
    obj = obj[args[i]];
  }
  return true;
}
